import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoGrey = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 40,
	viewBox: "0 0 43 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6182 0H42.0272V10.0016H31.6182V0Z",
			fill: "#4E5D78",
			fillOpacity: .898
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2031 10.0078H31.6166V20.0052H21.2031V10.0078Z",
			fill: "#4E5D78",
			fillOpacity: .749
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.79 10.0078H21.2035V20.0052H10.79V10.0078Z",
			fill: "#4E5D78",
			fillOpacity: .498
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.79 20H21.2035V30.0016H10.79V20Z",
			fill: "#4E5D78",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2031 20H31.6166V30.0016H21.2031V20Z",
			fill: "#4E5D78",
			fillOpacity: .498
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.0272 10H31.6182V19.9973L42.0272 10Z",
			fill: "#4E5D78",
			fillOpacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.6176 30H21.2041V40.0016L31.6176 30Z",
			fill: "#4E5D78",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2041 10.0016H31.6176V0L21.2041 10.0016Z",
			fill: "#4E5D78",
			fillOpacity: .6
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.375 19.9973H10.7885V10L0.375 19.9973Z",
			fill: "#4E5D78",
			fillOpacity: .4
		})
	]
});
const ForwardRef = forwardRef(SvgLogoGrey);
export { ForwardRef as ReactComponent };
